import { useRouter } from '#pplx/frontend/router/provider.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
export const useIsHomepage = () => {
    const { base } = useRouter();
    const pathname = usePathname();
    return (pathname === (base || '/') ||
        pathname?.startsWith('/welcome') ||
        // TODO (SHELWIN): Had to add this because internal hook falsifies it when not on homepage
        pathname?.startsWith('/finance'));
};
//# sourceMappingURL=useIsHomepage.js.map